import type { ReactNode } from 'react';
import { StaticBackground } from '@/features/styles/components/Background/StaticBackground';
import { Center, Flex, Image, Text } from '@/ui';
import cloud from './cloud.png';

type Props = {
  text?: string;
  children?: ReactNode;
};

export const ErrorState = ({
  text = "Oh no! We ran into an issue. Give it another try, but rest assurred we're on it",
  children,
}: Props) => {
  return (
    <Center flex="1" sx={{ '--experience-page-background': '#E9DFFF' }}>
      <StaticBackground />

      <Flex align="center" flexDir="column" gap="4">
        <Image maxW="70px" src={cloud} />

        <Text
          fontSize={{ base: 'xl', md: '3xl' }}
          fontWeight="bold"
          lineHeight="1.2"
          maxW="500px"
          px="10"
          sx={{ textWrap: 'balance' }}
          textAlign="center"
        >
          {text}
        </Text>

        {children}
      </Flex>
    </Center>
  );
};
